import script from "./InvoiceIPDTableUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceIPDTableUpdate.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceIPDTableUpdate.vue?vue&type=style&index=0&id=25960e39&lang=css"

const __exports__ = script;

export default __exports__